export default "__VITE_ASSET__zJ47fSXx__"